import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    height: "100%",
    margin: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.empty} ${theme.spacing.medium}`,
}));
